// extracted by mini-css-extract-plugin
var _1 = "webpack-components-core-Modal-components-ModalBody-module__ModalBody";
var _2 = "webpack-components-core-Modal-components-ModalBody-module__default";
var _3 = "webpack-components-core-Modal-components-ModalBody-module__brand";
var _4 = "webpack-components-core-Modal-components-ModalBody-module__brand-strong";
var _5 = "webpack-components-core-Modal-components-ModalBody-module__danger";
var _6 = "webpack-components-core-Modal-components-ModalBody-module__lg";
var _7 = "webpack-components-core-Modal-components-ModalBody-module__md";
var _8 = "webpack-components-core-Modal-components-ModalBody-module__medium";
var _9 = "webpack-components-core-Modal-components-ModalBody-module__neutral";
var _a = "webpack-components-core-Modal-components-ModalBody-module__primary";
var _b = "webpack-components-core-Modal-components-ModalBody-module__sm";
var _c = "webpack-components-core-Modal-components-ModalBody-module__strong";
var _d = "webpack-components-core-Modal-components-ModalBody-module__success";
var _e = "webpack-components-core-Modal-components-ModalBody-module__text";
var _f = "webpack-components-core-Modal-components-ModalBody-module__warning";
var _10 = "webpack-components-core-Modal-components-ModalBody-module__weak";
var _11 = "webpack-components-core-Modal-components-ModalBody-module__xl";
var _12 = "webpack-components-core-Modal-components-ModalBody-module__xs";
var _13 = "webpack-components-core-Modal-components-ModalBody-module__xxl";
export { _1 as "ModalBody", _2 as "_default", _3 as "brand", _4 as "brand-strong", _5 as "danger", _6 as "lg", _7 as "md", _8 as "medium", _9 as "neutral", _a as "primary", _b as "sm", _c as "strong", _d as "success", _e as "text", _f as "warning", _10 as "weak", _11 as "xl", _12 as "xs", _13 as "xxl" }
